// Base (default) dashboard — only the two shared, department-agnostic cards: Frequent Access and
// Recent Transactions. Used for roles assigned the "Base" department and as the fallback for any
// role with no department (see DASHBOARD_COMPONENTS_BY_DEPARTMENT in RoleBasedApplication.jsx).
import React from 'react';
import { useSelector } from 'react-redux';
import FrequentAccessCard from './FrequentAccessCard';
import RecentTransactionsCard from './RecentTransactionsCard';

const BaseDashboard = ({ onNavigate, linkFrequency, trackMenuUsage }) => {
    const { roleData, userData } = useSelector((state) => state.auth);

    const userId = userData?.userId || userData?.UID || userData?.employeeId || '';
    const roleId = userData?.roleId || userData?.RID || 0;

    return (
        <div className="space-y-6">
            {/* Welcome Header */}
            <div className="bg-gradient-to-r from-[#0d1b5e] to-[#0a1240] dark:from-[#0a1240] dark:to-gray-900 rounded-lg p-6 text-white transition-colors">
                <h1 className="text-2xl font-bold mb-2">Welcome Back!</h1>
                <p className="text-orange-200 dark:text-orange-300">Employee: {userData?.firstName} | Role: {userData?.roleCode}</p>
            </div>

            {/* Quick access on one side, Recent Transactions on the other */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-start">
                <div className="lg:col-span-1">
                    <FrequentAccessCard
                        roleData={roleData}
                        linkFrequency={linkFrequency}
                        trackMenuUsage={trackMenuUsage}
                        onNavigate={onNavigate}
                    />
                </div>
                <div className="lg:col-span-2">
                    <RecentTransactionsCard roleId={roleId} userId={userId} />
                </div>
            </div>
        </div>
    );
};

export default BaseDashboard;
